import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20 pb-20 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-8xl font-bold font-heading text-background-300 mb-4">404</div>
          <h1 className="text-xl md:text-2xl font-bold text-foreground-800 mb-3">页面未找到</h1>
          <p className="text-foreground-500 text-sm mb-6 max-w-md mx-auto">
            您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页浏览其他内容。
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-full text-sm transition-all whitespace-nowrap"
            >
              <i className="ri-film-line"></i>
              浏览影视
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}